import { ComposicaoSimulacaoPrecoItemContract } from "app/types/simulacao-preco/ComposicaoSimulacaoPrecoItemContract"
import { ComposicaoCustoSimulacaoPrecoItemContract } from "app/types/simulacao-preco/ComposicaoCustoSimulacaoPrecoItemContract"
import clsx from "clsx"
import React, { useEffect, useState } from "react"
import { TipoPesquisaContract } from "app/types/simulacao-preco/TipoPesquisaContract"
import globalMU from "globalMU"
const estilosIcones = require('../../estilos/icones.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default
const estiloTabela = require('../../estilos/tabelas.module.scss').default

const NUMERO_CASAS_DECIMAIS_COLUNA_VALOR = 7

type TipoCalculo = {
    Oid: number,
    Nome: string
}

type ItemSimulacaoProps = {
    tiposPesquisa: TipoPesquisaContract[]
    itemSimulacao: ComposicaoSimulacaoPrecoItemContract
    somenteLeitura: boolean
    processando: boolean
    onDadosAlterados: (oidTipoPesquisa:number,valor:number, oidCalculo:number) => void
    onItemRemovido: () => void
}

const ItemSimulacao = (props: ItemSimulacaoProps) => {

    const [tiposCalculo] = useState<TipoCalculo[]>([
        {Oid: 23045, Nome: "Percentual"},
        {Oid: 23050, Nome: "Valor"}
    ])

    const obterDadosCalculo = (oidTipoPesquisa:number) : {oid: number, nome: string} => {
        const oid = props.tiposPesquisa.find(tipoPesquisa => tipoPesquisa.Oid == oidTipoPesquisa)?.OidCalculo

        const nome =    oid == 23045 ? "Percentual" :
                        oid == null ? "" : "Valor"

        return {oid,nome}
    }

    const [valor,setValor] = useState<string>(globalMU.formatarValorNumerico(props.itemSimulacao.Valor,NUMERO_CASAS_DECIMAIS_COLUNA_VALOR))
    const [oidTipoPesquisa,setOidTipoPesquisa] = useState(props.itemSimulacao.OidTipoPesquisa)
    const [oidTipoCalculo, setOidTipoCalculo] = useState(props.itemSimulacao.OidCalculo)

    useEffect(() => {
        setOidTipoPesquisa(props.itemSimulacao.OidTipoPesquisa)
        setValor(globalMU.formatarValorNumerico(props.itemSimulacao.Valor,NUMERO_CASAS_DECIMAIS_COLUNA_VALOR))
    },[props.itemSimulacao])


    return <tr>
        <td>
            <select
                 id="ItemSimulacao_OidTipoPesquisaSelect"
                value={(oidTipoPesquisa) ?? ""}
                disabled={oidTipoPesquisa != null}
                onChange={e => {
                    const _oidTipoPesquisa = Number(e.target.value)

                    setOidTipoPesquisa(_oidTipoPesquisa)

                    const {oid: _oidTipoCalculo} = obterDadosCalculo(_oidTipoPesquisa)

                    setOidTipoCalculo(_oidTipoCalculo)

                    props.onDadosAlterados(
                        _oidTipoPesquisa,
                        Number(globalMU.corrigirPontosEVirgulasValorDecimal(valor)),
                        _oidTipoCalculo)
                }}>
                <option value={null}></option>
                {props.tiposPesquisa.map(tipoPesquisa => <option key={tipoPesquisa.Oid} value={tipoPesquisa.Oid}>{tipoPesquisa.Nome}</option>)}
            </select>
        </td>
        <td>


            <select
                id="ItemSimulacao_OidTipoCalculoSelect"
                value={(oidTipoCalculo) ?? ""}
                onChange={e => {
                    const _oidTipoCalculo = Number(e.target.value)
                    setOidTipoCalculo(_oidTipoCalculo)

                    props.onDadosAlterados(
                        oidTipoPesquisa,
                        Number(globalMU.corrigirPontosEVirgulasValorDecimal(valor)),
                        _oidTipoCalculo)
                }}>
                {tiposCalculo.map(tipoCalculo => <option key={tipoCalculo.Oid} value={tipoCalculo.Oid}>{tipoCalculo.Nome}</option>)}
            </select>
        </td>
        <td>
            <input
                className={clsx("_w-40 text-right",estilosInputs.campoEntrada)}
                 id="ItemSimulacao_ValorInput"
                value={(valor) ?? ""}
                onKeyPress={e => {
                    if (!globalMU.teclaDigitadaEhValidaParaCampoNumerico(e.key,valor)) e.preventDefault()
                }}
                onChange={e => {
                    const _valor = e.target.value

                    setValor(_valor)
                }}
                onBlur={e => {
                    const _valor = Number(globalMU.corrigirPontosEVirgulasValorDecimal(e.target.value))

                    setValor(globalMU.formatarValorNumerico(_valor,NUMERO_CASAS_DECIMAIS_COLUNA_VALOR,false))

                    props.onDadosAlterados(oidTipoPesquisa,_valor,obterDadosCalculo(oidTipoPesquisa).oid)
                }}/>
        </td>
        
        <td>
        {!props.somenteLeitura &&
            <button onClick={props.onItemRemovido}
                disabled={props.processando}
                title="Remove a linha"
                 id="ItemSimulacao_RemoverItemButton"
            >
                <i className={clsx(estilosIcones.icone,"material-icons")}>delete</i>
            </button>
}
        </td>

    </tr>

}

export {
    ItemSimulacao,
    ItemSimulacaoProps
}

